import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AdminJobOfferTalentCommentsDialogComponent } from "./admin-job-offer-talent-comments-dialog.component";
import { NzModalModule } from "ng-zorro-antd/modal";
import { TranslateModule } from "@ngx-translate/core";
import { JobOfferTalentCommentsModule } from "../../../../../../../../common-ui/src/lib/job-offer-talent-comments/job-offer-talent-comments.module";

@NgModule({
  declarations: [AdminJobOfferTalentCommentsDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NzModalModule,
    JobOfferTalentCommentsModule,
  ],
  exports: [AdminJobOfferTalentCommentsDialogComponent],
})
export class AdminJobOfferTalentCommentsDialogModule {}
